export default {
  state: {
    currentUser: null,
    all: []
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user
    },
    clearCurrentUser(state) {
      state.currentUser = null
    },
    setUsers(state, users) {
      Object.assign(state.all, users.users)
    },
    setUser(state, user) {
      Object.assign(
        state.all.find(x => x.id === user.id),
        user
      )
    },
    addUser(state, user) {
      state.all.push(user)
    },
    removeUser(state, user) {
      state.all = state.all.filter(x => x.id !== user.id)
    }
  },
  actions: {},
  getters: {
    getUserByFullName: state => fullname => {
      return state.all.find(user => {
        return (
          `${user.firstName.toLowerCase()} ${user.lastName.toLowerCase()}` ==
          fullname.toLowerCase()
        )
      })
    },
    getCurrentUser: state => {
      return state.currentUser
    },
    getUserById: state => id => {
      return state.all.find(x => x.id === id)
    },
    getUserByEmail: state => email => {
      return state.all.find(x => x.email.toLowerCase() === email.toLowerCase())
    }
  }
}
